import defaultStyles from "@stadium/ui/src/components/brands/main.module.scss";

import stadium from "@stadium/ui/src/assets/images/svg/stadium-logo.svg";
import snackmagic from "@stadium/ui/src/assets/images/svg/snackmagic.svg";
import swagmagicNew from "@stadium/ui/src/assets/images/svg/brands/swagmagic-white.svg";

import snackmagicBgImg from "@stadium/ui/src/assets/images/snackmagic-hover-img.png";
import swagmagicBgImg from "@stadium/ui/src/assets/images/swagmagic-hover-img.png";
import stadiumBgImg from "@stadium/ui/src/assets/images/stadium-hover-img.png";

import snackmagicFooterImg from "@stadium/ui/src/assets/images/svg/footer/snackmagic.svg";
import swagmagicFooterImg from "@stadium/ui/src/assets/images/svg/footer/swagmagic.svg";

import { BYSTADIUM_MARKETING_URL } from "@stadium/helpers/app-routes";

const SWAGMAGIC_PROMOTIONAL_DOMAIN = process.env.NEXT_PUBLIC_PROMOTIONAL_STORE_DOMAIN;
const SWAGMAGIC_PROMOTIONAL_ORIGIN = SWAGMAGIC_PROMOTIONAL_DOMAIN
  ? `https://${SWAGMAGIC_PROMOTIONAL_DOMAIN}`
  : undefined;

const HEADER_BRANDS = ({ styles = defaultStyles } = {}) => [
  {
    name: "stadium",
    url: BYSTADIUM_MARKETING_URL,
    imgSrc: stadium,
    imgAlt: "Stadium",
    imgWidth: 184,
    footerImgWidth: 128,
    mbImgWidth: 128,
    mbBgImgHt: 74,
    backgroundImg: stadiumBgImg,
    bannerBGClass: styles.brandItemBgStadium,
    logoHoverBg: styles.logoBgStadium,
  },
  {
    name: "snackmagic",
    url: process.env.NEXT_PUBLIC_SNACKMAGIC_TEST_URL || "https://www.snackmagic.com/",
    imgSrc: snackmagic,
    imgAlt: "Snackmagic",
    imgWidth: 184,
    footerImgWidth: 128,
    mbImgWidth: 128,
    mbBgImgHt: 74,
    backgroundImg: snackmagicBgImg,
    footerImg: snackmagicFooterImg,
    bannerBGClass: styles.brandItemBgSnackmagic,
    logoHoverBg: styles.logoBgSnackmagic,
  },
  {
    name: "swagmagic",
    url:
      SWAGMAGIC_PROMOTIONAL_ORIGIN ||
      process.env.NEXT_PUBLIC_SWAGMAGIC_TEST_URL ||
      "https://www.swagmagic.com/",
    imgSrc: swagmagicNew,
    imgAlt: "SwagMagic",
    imgWidth: 184,
    footerImgWidth: 132,
    mbImgWidth: 132,
    mbBgImgHt: 90,
    backgroundImg: swagmagicBgImg,
    footerImg: swagmagicFooterImg,
    bannerBGClass: styles.brandItemBgSwagmagic,
    logoHoverBg: styles.logoBgSwagmagic,
  },
];

export default HEADER_BRANDS;
